'use client'
import { loginWithGoogleAction } from '@/actions'
import { CALLBACK_URL_KEY } from '@/constants'
import { getInfoCustomer } from '@/features/auth/services'
import { setRef } from '@/features/ref/utils/setRef'
import { setCookies } from '@/libs/cookies'
import { useRouter } from '@/libs/i18n/routing'
import { useAccountStore, useCartStore, useCompareStore } from '@/store'
import { DEFAULT_LOGIN_REDIRECT } from '@/utils/routes'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

interface ReferralData {
  referrer?: string
  refCode?: string
}

export const useLoginGoogle = (): { isLoading: boolean } => {
  const router = useRouter()
  const [isLoading, setIsLoading] = useState(false)
  const { setUser } = useAccountStore()
  const { mergeCart } = useCartStore()
  const { assignToUser } = useCompareStore()
  const handleLoginGoogle = async (token: string) => {
    let dataSearch
    if (typeof window !== 'undefined') {
      let convertString = `${window.location.search}`.substring(1)
      dataSearch = JSON.parse(
        '{"' + decodeURI(convertString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}'
      )
    }
    return await loginWithGoogleAction(dataSearch)
      .then(async (res) => {
        setCookies(res?.data, true)

        await mergeCart()
        // await assignToUser()
        const callbackUrl = localStorage.getItem(CALLBACK_URL_KEY)
        let redirectUrl = callbackUrl ?? DEFAULT_LOGIN_REDIRECT

        window.location.href = redirectUrl
        localStorage.removeItem(CALLBACK_URL_KEY)
      })
      .catch((error) => {
        toast.error(error.message || 'Đăng nhập thất bại')
        throw error
      })
  }

  useEffect(() => {
    if (window.location.href.includes('handle=google')) {
      const isLoginFailed = window.location.href.includes('error=')
      if (isLoginFailed) {
        toast.error('Đăng nhập thất bại')
        // router.push('/')
      } else {
        setIsLoading(true)
        const convertString = `${window.location.search}`.substring(1)
        const dataSearch = JSON.parse(
          '{"' +
            decodeURI(convertString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') +
            '"}'
        )
        handleLoginGoogle(dataSearch.code)
          .then(async (res) => {
            toast.success('Đăng nhập thành công')
          })
          .catch((error) => {
            console.error('Login error:', error)
          })
          .finally(() => {
            setIsLoading(false)
          })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { isLoading }
}
